import { render, staticRenderFns } from "./Triangular.vue?vue&type=template&id=07f60b60&"
import script from "./Triangular.vue?vue&type=script&lang=js&"
export * from "./Triangular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Triangular.vue"
export default component.exports